export default __webpack_public_path__ + "static/media/defaultmentorprofile.706c5aa0.png";